import { Button } from "@/src/components/buttons";
import { Card } from "@/src/components/cards";
import { openDrawer } from "@/src/components/dialogs";
import {
  Confidentiality,
  ConfidentialityDemand,
  confidentialityDemandStatuses,
  Patient,
  PatientLight,
} from "@/src/data/allTypes";
import { USER } from "@/src/data/globalVariables";
import apiFetch from "@/src/utils/apiFetch";
import {
  getItemId,
  getItemsIds,
  getName,
  getRemedType,
  getServiceId,
  getUserId,
  isAdmin,
  isSuperAdmin,
  jsonAbstract,
} from "@/src/utils/utils";
import { MdLockOutline } from "react-icons/md";
import { sendSimpleNotification } from "../notifications/notificationsHook";

export function getStandardConfidentiality(
  patient: Patient | null | undefined
): Confidentiality {
  return {
    type: "services",
    patient: getItemId(patient),
    creator: getUserId(),
    services: [getServiceId()],
    specialities: [],
    demands: [],
    units: [],
    users: [],
  };
}

export function ConfidentialityCard({
  item,
  children,
  onChange,
}: {
  item: any;
  onChange?: () => void;
  children?: any;
}) {
  let confidentiality: Confidentiality | null | undefined =
    item?.confidentiality;

  function isPendingRequest() {
    return (
      confidentiality?.demands?.find(
        (access) => access?.user == getUserId() && access?.status == "pending"
      ) != null
    );
  }

  if (!hasAccess(confidentiality)) {
    return (
      <Card
        color="simple"
        leading={<MdLockOutline size={25} />}
        title={"Vous n'avez pas accès à cet élément"}
      >
        {isPendingRequest() ? (
          <div className="gray mtop5">Demande d accès en attente...</div>
        ) : (
          <div className="mtop10">
            <Button
              type={"tertiary"}
              onClick={async () => {
                console.log("confidentiality", confidentiality);
                let demand = await apiFetch(
                  "confidentiality",
                  "addConfidentialityDemand",
                  {
                    parentId: item.id,
                    userId: getUserId(),
                    confidentialityId: confidentiality?.id,
                  }
                );
                onChange?.();
                sendSimpleNotification({
                  type: "confidentialityDemand",
                  item: demand,
                  targetUsers: jsonAbstract([confidentiality?.creator]),
                });
              }}
            >
              Demander accès
            </Button>
          </div>
        )}
      </Card>
    );
  }

  return children;
}

export async function openConfidentialityDemandDrawer({
  demand,
}: {
  demand: ConfidentialityDemand;
}) {
  let item = await apiFetch("confidentiality", "loadConfidentialityParent", {
    parentId: demand.parentId,
  });
  if (!item) throw new Error("Item not found");
  let status = confidentialityDemandStatuses[demand.status];

  await openDrawer({
    id: "confidentialityDemand",
    title: "Demande d'accès",
    content: (
      <div className="c1 gap10">
        <div className={`br p5 ${status?.color}ish`}>{status.name}</div>
        <div>{getName(item.patient)}</div>
        <div>Type: {item.type}</div>
        <div className="bold">{item.reference?.name}</div>
        <div className="gray">{item._date}</div>
      </div>
    ),
    onConfirm:
      demand.status == "granted"
        ? undefined
        : async () => {
            let result = await apiFetch(
              "confidentiality",
              "grantConfientialityDemand",
              {
                demandId: demand.id,
                grantedBy: getUserId(),
              }
            );

            sendSimpleNotification({
              item: result,
              type: "confidentialityAnswer",
              targetUsers: [getItemId(result?.user)],
            });
          },
  });
}

export function hasAccessToPatient(
  patient: Patient | PatientLight | null | undefined
) {
  if (getRemedType() == "FORENXPERT") return true;
  if (!patient) return false;

  return (
    getItemsIds(patient.services || []).includes(getServiceId()) ||
    hasAccess(patient?.confidentiality)
  );
}
export function hasAccess(
  confidentiality: Confidentiality | null | undefined
): boolean {
  if (!confidentiality) return true;
  if (
    isSuperAdmin(USER.get()) ||
    isAdmin(USER.get()) ||
    USER.get()?.role?.name.includes("chef ")
  )
    return true;
  if (typeof confidentiality == "string") return false;

  if (
    confidentiality.demands?.find(
      (demand) =>
        getItemId(demand?.user) == getUserId() && demand?.status == "granted"
    )
  )
    return true;

  if (confidentiality.type == "services") {
    let serviceId = getServiceId();
    if (!serviceId) return false;
    if (!confidentiality.services?.includes(serviceId)) return false;
  }

  // if (
  //   USER.get()?.service?.name?.includes("légal") &&
  //   !confidentiality.users?.includes(getUserId()) &&
  //   confidentiality?.creator != getUserId()
  // ) {
  //   confidentiality.type = "users";
  // }

  if (confidentiality.type == "users") {
    let userId = getUserId();
    if (!userId) return false;
    if (!confidentiality.users?.includes(userId)) return false;
  }
  if (confidentiality.type == "all") return true;
  return true;
}
